import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/mh_small_bg_64.png'


const _hoisted_1 = { class: "mobile-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Mediocre Hobbies"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "hamb",
  for: "side-menu"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "hamb-line" })
], -1)
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = { class: "menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "logo"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("input", {
      class: "side-menu",
      type: "checkbox",
      id: "side-menu",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isMenuOpen) = $event))
    }, null, 512), [
      [_vModelCheckbox, _ctx.isMenuOpen]
    ]),
    _hoisted_3,
    _createElementVNode("nav", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/",
            "exact-active-class": "active",
            onClick: _ctx.closeMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/videos",
            "active-class": "active",
            onClick: _ctx.closeMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode("Videos")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/stream",
            "active-class": "active",
            onClick: _ctx.closeMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode("Stream")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/merch",
            "active-class": "active",
            onClick: _ctx.closeMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode("Merch")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/affiliates",
            "active-class": "active",
            onClick: _ctx.closeMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode("Affiliates")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/campaigns",
            "active-class": "active",
            onClick: _ctx.closeMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode("Campaign")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}